import {
  Box,
  Typography,
  Stack,
  useMediaQuery,
  Button,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CardPayment from "../components/CardPayment";

const CompraInicial = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: { xs: "auto", xl: "100vh" },
        backgroundImage: "url(/assets/bg-payments.png)",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "auto",
          backgroundColor: "rgba(0, 0, 0, 0.714)",
          backdropFilter: "blur(6px)",
          zIndex: 9,
          gap: "40px",
          padding: "10px",
          marginTop: { xs: "25px", xxl: 0 },
        }}
      >
        <Box
          component="img"
          src="/assets/plusvalica_logo.svg"
          alt="Logo Plusvalica"
          width={500}
          height={60}
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />

        <Box textAlign="center" color="white">
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 600,
              textAlign: "center",
              fontFamily: 'Montserrat", sans-serif',
              lineHeight: 1.2,
              letterSpacing: "0.03em",
              margin: "0 0 0.5rem 0",
            }}
          >
            Fondea tu wallet para hacer tu primer compra
          </Typography>
          <Typography variant="h6" color="#98989A" sx={{ fontWeight: 500 }}>
            Por favor, selecciona tu método de depósito: <br />
            Criptomoneda o dinero tradicional mediante transferencia o depósito.
          </Typography>
        </Box>

        <Stack
          direction={{ xs: "column", lg: "row" }}
          justifyContent="center"
          alignItems="center"
          width="100%"
          maxWidth="1200px"
          spacing={4}
          padding="5px"
        >
          <CardPayment
            currency="USDT"
            icon="/assets/usdt.png"
            text="Paga usando USDT en la red de Binance Smart Chain."
            href="/payments/method?type=usdt"
            buttonText="PAGAR"
          />

          <CardPayment
            currency="Kotaro"
            icon="/assets/logo-kotaro.png"
            text="Paga haciendo una transferencia o depósito bancario."
            href="/payments/method?type=kotaro"
            buttonText="PAGAR"
          />
        </Stack>

        <Button
          onClick={() => navigate("/")}
          sx={{
            marginBottom: 8,
            textDecoration: "underline",
            fontSize: "18px",
            color: "#98989A",
          }}
        >
          Omitir este paso e ir directamente a Plusval State
        </Button>
      </Box>
    </Box>
  );
};

export default CompraInicial;
